<div class="modal" [ngClass]="{'show' :config?.showOrderSucceeded}">
  <div class="modal-content">
    <div class="modal-content__body-container">
      <div class="model-header">
        <h3 [translate]="titleKey" class="no-margin-bottom"></h3>
        <img *ngIf="config.showLogo" src="{{logoUrl}}" class="modal-logo">
      </div>
      <p [translate]="descriptionKey" [translateParams]="{packageName: getPackageName()}" class="marginBottom40"></p>

      <app-qr-tile [title]="qrTitle"
                   [description]="qrDescription"
                   [QRCodeType]="qrCodeType"
                   *ngIf="isSubscribedStreamingPack"
      ></app-qr-tile>

      <app-spacer [spacerSize]="40"></app-spacer>

      <app-navigable-button
        [x]="0"
        [y]="0"
        [ownerComponent]="componentName"
        class="btn-grey"
        (emitOnEnterPressed)="onEmitCloseOrderSucceeded()"
        (emitOnBack)="onBack()">
        <span [translate]="closeButtonTextKey"></span>
      </app-navigable-button>
    </div>
  </div>
</div>
